// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

.dropdowns {
  border-radius: 5px;
  border: 1px solid #e1e3ea;
  padding: 3px 5px;
  margin-bottom: 20px;
}
.dropdowns ::ng-deep .mat-mdc-select-placeholder {
  font-size: 12px !important;
}
.dropdowns ::ng-deep .mat-mdc-select-value-text {
  color: #535353 !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}

::ng-deep .mat-mdc-option {
  padding: 5px !important;
}

::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked {
  font-size: 12px;
}

::ng-deep .ng-option {
  font-size: 12px !important;
}
::ng-deep .ng-option:hover {
  background-color: #f2f4ff !important;
  color: #3e97ff !important;
}

::ng-deep .ng-option-label {
  font-size: 12px;
}

::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,
.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label {
  color: #3e97ff !important;
}

::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected {
  background-color: #f2f4ff;
  font-size: 12px !important;
}

::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,
.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label {
  font-weight: 400 !important;
}
::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label:hover,
.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label:hover {
  color: #3e97ff !important;
}

::ng-deep .add-associate-drop-down .ng-dropdown-panel .scroll-host {
  height: auto !important;
}

.add-associate-drop-down ::ng-deep .ng-placeholder {
  color: red !important;
}

.selectClass {
  font-size: 12px !important;
  margin: 7px 0px;
  background-image: url('dropdown.svg');
  background-repeat: no-repeat;
  background-position-x: 96%;
  background-position-y: center;
  background-color: #f2f4ff;
  border-radius: 5px;
  width: 50% !important;
  padding: 5px !important;
  text-align: center;
}
.selectClass mat-select ::ng-deep .mdc-list-item__primary-text {
  margin: 0px 40px !important;
}

::ng-deep .mdc-list-item__primary-text {
  font-size: 12px !important;
}
::ng-deep .mdc-list-item__primary-text:hover {
  color: #3e97ff !important;
}

.select {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 50px;
}

.remarkTxt {
  margin-bottom: 15px;
}

ng-select {
  padding-bottom: 15px;
}

::ng-deep .ng-select.ng-select-single .ng-select-container .ng-clear-wrapper {
  display: flex;
  align-items: center;
}

.image {
  width: 20px;
  height: 20px;
}

.block {
  cursor: no-drop !important;
}

::ng-deep .add-associate-modal {
  width: 38vw !important;
}

::ng-deep .add-associate-dialog ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  height: auto !important;
  max-height: 530px;
  overflow: hidden;
}

.no-gutter {
  width: 480px;
  padding: 30px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.fm-title {
  margin-bottom: 15px !important;
  font-size: 16px !important;
}

.btn-continue {
  margin-bottom: 30px !important;
}

::ng-deep .ng-arrow-wrapper {
  margin-bottom: -5px;
}

::ng-deep .ng-value {
  margin-top: -10px !important;
  padding-left: 8px;
}

::ng-deep .ng-placeholder {
  display: none !important;
}

.add-associate-modal {
  border-radius: 20px;
  background-color: #ffffff;
}

.dialog-header {
  min-height: 229px;
  max-height: 230px;
  display: block;
  text-align: right;
  background: #ffffff;
  background-image: url('deleteFingerprint.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  background-size: cover;
}
.dialog-header .close {
  margin: 10px;
}
.dialog-header img {
  cursor: pointer;
  margin-top: -3px;
}

.dialog-body {
  padding-bottom: 20px;
  position: relative;
  max-height: 315px;
  min-height: 230px;
  overflow: auto;
}
.dialog-body .enroll-status {
  margin-top: 15%;
  margin-bottom: 15%;
}
.dialog-body .shift-up .scan-info {
  margin-top: 5% !important;
}
.dialog-body .btn-actions {
  padding-bottom: 20px;
}
.dialog-body .btn-actions button:nth-of-type(even) {
  margin-left: 10px;
}
.dialog-body .img-wrapper,
.dialog-body .scanned-img-wrapper {
  margin-left: 38%;
  margin-top: 8%;
  text-align: center;
  vertical-align: middle;
}
.dialog-body .img-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-image: linear-gradient(135deg, #519548, #88c425);
}
.dialog-body .img-wrapper img {
  width: 60%;
  height: 60%;
  margin-top: 25%;
}
.dialog-body .scanned-img-wrapper {
  width: 100px;
  height: 100px;
}
.dialog-body .add-space {
  margin-bottom: 14%;
  margin-top: 25%;
  text-align: center;
  vertical-align: middle;
}
.dialog-body .add-info {
  margin-top: 12px;
  font-size: 20px;
  color: #707070;
}
.dialog-body .scan-info {
  color: #3e97ff;
}
.dialog-body .agent-info {
  width: 86%;
  margin-left: 7%;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  background-image: linear-gradient(99deg, #f54828, #f7803c);
}
.dialog-body .agent-info .info-header,
.dialog-body .agent-info .info-header- {
  padding: 9px 12px 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 40px;
}
.dialog-body .agent-info .info-header p,
.dialog-body .agent-info .info-header- p {
  color: #ffffff;
}
.dialog-body .agent-info .info-header img,
.dialog-body .agent-info .info-header- img {
  width: 23px;
}
.dialog-body .agent-info .info-header-1,
.dialog-body .agent-info .info-header-1- {
  padding: 9px 12px 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 103px;
}
.dialog-body .agent-info .info-header-1 p,
.dialog-body .agent-info .info-header-1- p {
  color: #ffffff;
}
.dialog-body .agent-info .info-header-1 img,
.dialog-body .agent-info .info-header-1- img {
  width: 23px;
}
.dialog-body .agent-info .info-header-green {
  background-image: linear-gradient(99deg, #519548, #519548);
}
.dialog-body .agent-info .info-header-red {
  background-image: linear-gradient(99deg, #ff0000, #ff0000);
}
.dialog-body .agent-info .info-header-orange {
  background-image: linear-gradient(99deg, #fdb71a, #fdb71a);
}
.dialog-body .agent-info .info-body {
  padding: 15px 20px 0px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.dialog-body .agent-info .info-body table tbody tr td {
  padding: 0px !important;
  border: none !important;
  text-align: left;
  font-size: 14px;
}
.dialog-body .agent-info .info-body table tbody tr td:first-child {
  color: #2d2d2d;
  width: 45%;
}
.dialog-body .agent-info .info-body table tbody tr td:last-child {
  color: #707070;
  width: 55%;
}
.dialog-body .form-section {
  width: 100%;
  max-width: 380px;
}
.dialog-body .form-section .fm-title {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #3e97ff;
  margin-bottom: 5px;
  margin-left: 4%;
  text-align: left;
}
.dialog-body .form-section .form-group {
  width: 44%;
  margin-left: 4%;
  text-align: left;
  margin-bottom: 0px !important;
  margin-top: -15px !important;
}
.dialog-body .form-section .form-group label {
  font-size: 10px;
  margin-bottom: 0 !important;
  color: #707070;
}
.dialog-body .form-section .form-group .form-control {
  height: calc(2.4em + 0.75rem - 5px) !important;
  max-width: 380px;
  padding: 0 5px;
  font-size: 12px !important;
  color: #535353;
}
.dialog-body .form-section .form-group .form-control:focus, .dialog-body .form-section .form-group .form-control:active {
  outline: none !important;
  box-shadow: none !important;
}
.dialog-body .form-section .form-group .error-section {
  min-height: 15px;
}
.dialog-body .form-section .form-group .error-section .err-msg {
  font-size: 9px !important;
}
.dialog-body .mismatch {
  display: grid;
  justify-content: center;
  align-items: center;
  padding: 30px;
  border: 1px dotted #181c32;
  background-color: #fff5f8;
  margin: 40px 40px;
}
.dialog-body .mismatch p {
  font-size: 14px;
  color: #181c32;
  font-weight: bold;
}
.dialog-body .leftSuccess {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px dotted #181c32;
  background-color: #f2f4ff;
  margin: 20px;
}
.dialog-body .leftSuccess img {
  max-width: 100%;
  width: 30px !important;
  height: auto;
}
.dialog-body .leftSuccess p {
  font-size: 14px;
  color: black;
  font-weight: bold;
}
.dialog-body .leftSuccess button:hover {
  background-color: #3e97ff;
}
.dialog-body .continue {
  padding: 10px 10px;
  background-color: #3e97ff;
  color: #ffffff;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 12px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.dialog-body .continue span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.dialog-body .continue::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}
.dialog-body .continue:hover::before {
  left: 0;
}
.dialog-body .deviceErr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px dotted #181c32;
  background-color: #fff5f8;
  margin: 20px;
  font-weight: bold;
}
.dialog-body .leftFailed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px dotted #181c32;
  background-color: #fff5f8;
  margin: 20px;
}
.dialog-body .leftFailed img {
  max-width: 100%;
  width: 30px !important;
  height: auto;
}
.dialog-body .leftFailed p {
  font-size: 14px;
  color: black;
  font-weight: bold;
}
.dialog-body .leftFailed button:hover {
  background-color: #3e97ff;
}
.dialog-body .tryAgain {
  padding: 10px 10px;
  background-color: #3e97ff;
  color: #ffffff;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 12px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.dialog-body .tryAgain span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.dialog-body .tryAgain::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}
.dialog-body .tryAgain:hover::before {
  left: 0;
}
.dialog-body .btn-contact {
  display: inline-block;
  margin-bottom: 0;
  line-height: 19px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 300;
  height: 38px;
  min-width: 210px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-right: 8px;
  margin-left: 6px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.dialog-body .btn-contact:disabled {
  cursor: not-allowed;
}
.dialog-body .btn-contact:focus {
  outline: none;
}
.dialog-body .btn-contact:hover, .dialog-body .btn-contact:focus, .dialog-body .btn-contact:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.dialog-body .btn-contact:hover, .dialog-body .btn-contact:focus, .dialog-body .btn-contact:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.dialog-body .btn-contact span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.dialog-body .delete-assc {
  display: inline-block;
  margin-bottom: 0;
  line-height: 19px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 300;
  height: 38px;
  min-width: 210px;
  background: #FF4F4F;
  color: #ffffff;
  position: relative;
  text-align: center;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-right: 8px;
  margin-left: 6px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.dialog-body .delete-assc:disabled {
  cursor: not-allowed;
}
.dialog-body .delete-assc:focus {
  outline: none;
}
.dialog-body .delete-assc:hover, .dialog-body .delete-assc:focus, .dialog-body .delete-assc:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.dialog-body .delete-assc:hover, .dialog-body .delete-assc:focus, .dialog-body .delete-assc:active {
  background: #FF4F4F;
  color: #ffffff;
  border: 1px solid #FF4F4F;
}
.dialog-body .delete-assc span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.dialog-body .btn-continue,
.dialog-body .add-assc {
  display: inline-block;
  margin-bottom: 0;
  line-height: 19px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 300;
  height: 38px;
  min-width: 210px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-right: 8px;
  margin-left: 6px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.dialog-body .btn-continue:disabled,
.dialog-body .add-assc:disabled {
  cursor: not-allowed;
}
.dialog-body .btn-continue:focus,
.dialog-body .add-assc:focus {
  outline: none;
}
.dialog-body .btn-continue:hover, .dialog-body .btn-continue:focus, .dialog-body .btn-continue:active,
.dialog-body .add-assc:hover,
.dialog-body .add-assc:focus,
.dialog-body .add-assc:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.dialog-body .btn-continue:hover, .dialog-body .btn-continue:focus, .dialog-body .btn-continue:active,
.dialog-body .add-assc:hover,
.dialog-body .add-assc:focus,
.dialog-body .add-assc:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.dialog-body .btn-continue span,
.dialog-body .add-assc span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.dialog-body .hoverEffect::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}
.dialog-body .hoverEffect:hover::before {
  left: 0;
}
.dialog-body .scan {
  display: grid;
  grid-template-columns: 1fr 2fr;
  border: 1px dotted #181c32;
  background-color: #f2f4ff;
  padding: 20px;
  margin: 20px;
  border-radius: 5px;
}
.dialog-body .scan img {
  justify-self: end;
  margin-right: 10px;
}
.dialog-body .scan p {
  text-align: left;
  font-size: 12px;
  font-weight: bold;
}
.dialog-body .match {
  display: grid;
  grid-template-columns: 1fr 3fr;
  border: 1px dotted #181c32;
  background-color: #f2f4ff;
  padding: 20px;
  margin: 20px;
  border-radius: 5px;
}
.dialog-body .match img {
  justify-self: end;
  margin-right: 10px;
  max-width: 100%;
  width: 30px !important;
  height: auto;
}
.dialog-body .match p {
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
}
.dialog-body .failedSaving {
  display: grid;
}
.dialog-body .failedSaving p {
  padding: 10px 0px;
}
.dialog-body .outer {
  display: grid !important;
}
.dialog-body .redFlagErr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #e8fff3;
}
.dialog-body .redFlagErr img {
  max-width: 100%;
  width: 30px !important;
  height: auto;
}
.dialog-body .redFlagErr p {
  font-size: 14px;
  color: black;
  font-weight: bold;
}
.dialog-body .redFlagErr button:hover {
  background-color: #3e97ff;
}
.dialog-body .new {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px dotted #181c32;
  background-color: #e8fff3;
  margin: 20px;
}
.dialog-body .new img {
  max-width: 100%;
  width: 30px !important;
  height: auto;
}
.dialog-body .new p {
  font-size: 14px;
  color: black;
  font-weight: bold;
}
.dialog-body .new button:hover {
  background-color: #3e97ff;
}
.dialog-body .contactCss {
  display: flex;
  flex-direction: column;
}
.dialog-body .redFlag {
  background-color: #fff5f8;
  justify-content: center;
}
.dialog-body .redFlag p {
  margin-left: 20px;
}
.dialog-body .exists {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px dotted #181c32;
  background-color: #e8fff3;
  margin: 20px;
}
.dialog-body .exists img {
  max-width: 100%;
  width: 30px !important;
  height: auto;
}
.dialog-body .exists p {
  font-size: 14px;
  color: black;
  font-weight: bold;
}
.dialog-body .exists button:hover {
  background-color: #3e97ff;
}
.dialog-body .terms {
  margin: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-body .btn-continue {
  background-color: #3e97ff !important;
  color: #ffffff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}
.dialog-body .slider-wrapper {
  margin-top: 30px;
  margin-bottom: 20px;
}
.dialog-body .slider-wrapper mat-slider {
  height: 48px;
  width: 78%;
}
.dialog-body .new-assc,
.dialog-body .success,
.dialog-body .failure {
  font-size: 18px;
  font-weight: 500;
}
.dialog-body .success {
  color: #5a9d42;
}
.dialog-body .failure {
  color: #f54a28;
}
.dialog-body .new-assc {
  color: #ff9900;
}

.saving {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dotted #181c32;
  justify-content: center;
  background-color: #e8fff3;
  margin: 40px 40px;
  padding: 30px;
}
.saving p {
  font-size: 14px;
  color: #50cd89;
  font-weight: bold;
  text-align: center;
}

.savingFailed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dotted #181c32;
  justify-content: center;
  background-color: #fff5f8;
  margin: 40px 40px;
  padding: 30px;
}
.savingFailed p {
  font-size: 14px;
  color: #181c32;
  font-weight: bold;
  text-align: center;
}

.updateSucess {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dotted #181c32;
  justify-content: center;
  background-color: #f2f4ff;
  margin: 40px 40px;
  padding: 30px;
}
.updateSucess p {
  font-size: 14px;
  color: #50cd89;
  font-weight: bold;
  text-align: center;
}

::ng-deep .ng-select.ng-select-disabled > .ng-select-container {
  background-color: #e9ecef;
}

::ng-deep .ng-select.ng-select-disabled > .ng-select-container > .ng-value-container > .ng-value {
  color: #535353 !important;
}

::ng-deep .ng-select .ng-select-container:after {
  border-bottom: none;
}

.addColor {
  background-color: white !important;
}

.removeColor {
  background-color: none;
}

.table-responsive {
  margin-top: 10px;
  box-shadow: none;
  border: 2px dotted #ffa800;
  margin: 15px;
  border-radius: 5px;
}
.table-responsive table {
  font-family: "Poppins" !important;
  box-shadow: none;
  border: none;
}
.table-responsive table thead tr th {
  font-size: 14px;
  border-bottom: none;
  vertical-align: middle;
  color: black;
  text-align: left;
}
.table-responsive table tbody tr td {
  border-bottom: none;
  min-width: 100px;
  vertical-align: middle;
  font-size: 13px;
}
.table-responsive table tbody tr td .name {
  font-weight: bold;
  text-align: left;
}
.table-responsive table tbody tr td .flexId {
  font-weight: bold;
  text-align: left;
}
.table-responsive table tbody tr td .name-icon .prof {
  text-transform: uppercase;
  cursor: pointer;
  border-right: 1px solid #f3f3f3;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  border-left: 1px solid #f3f3f3;
  border-radius: 3px;
  padding: 6px 12px;
  font-size: 18px;
  text-align: center;
  margin-right: 10px;
  background: #ffa800;
  color: #ffffff;
}
.table-responsive table tbody tr td .user-des .mobile {
  color: #959cbd;
  text-align: left;
}
.table-responsive table tbody tr td .site-name {
  color: #959cbd;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/common/fingerprint/fingerprint.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;AA/PA;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAkQF;AAhQE;EACE,0BAAA;AAkQJ;AA/PE;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;AAiQJ;;AA5PA;EACE,uBAAA;AA+PF;;AA5PA;EACE,eAAA;AA+PF;;AA5PA;EACE,0BAAA;AA+PF;AA7PE;EACE,oCAAA;EACA,yBAAA;AA+PJ;;AA3PA;EACE,eAAA;AA8PF;;AA3PA;;EAEE,yBAAA;AA8PF;;AA3PA;EACE,yBDNc;ECOd,0BAAA;AA8PF;;AA1PA;;EAEE,2BAAA;AA6PF;AA3PE;;EACE,yBAAA;AA8PJ;;AA1PA;EACE,uBAAA;AA6PF;;AA1PA;EACE,qBAAA;AA6PF;;AA1PA;EACE,0BAAA;EACA,eAAA;EACA,qCAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBDnCc;ECoCd,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;AA6PF;AA1PI;EACE,2BAAA;AA4PN;;AAvPA;EACE,0BAAA;AA0PF;AAxPE;EACE,yBAAA;AA0PJ;;AAtPA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAyPF;;AAtPA;EACE,mBAAA;AAyPF;;AAtPA;EACE,oBAAA;AAyPF;;AAtPA;EACE,aAAA;EACA,mBAAA;AAyPF;;AAtPA;EACE,WAAA;EACA,YAAA;AAyPF;;AAtPA;EACE,0BAAA;AAyPF;;AAtPA;EACE,sBAAA;AAyPF;;AArPE;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;AAwPJ;;AApPA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAuPF;;AApPA;EACE,8BAAA;EACA,0BAAA;AAuPF;;AApPA;EACE,8BAAA;AAuPF;;AApPA;EACE,mBAAA;AAuPF;;AApPA;EACE,4BAAA;EACA,iBAAA;AAuPF;;AApPA;EACE,wBAAA;AAuPF;;AApPA;EACE,mBAAA;EAEA,yBD/FM;ACqVR;;AAnPA;EAME,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EDlDA,mBAzDM;EA0DN,8CCsDE;EDrDF,2BCsDE;EDrDF,4BCsDE;EDrDF,qBCsDE;EACF,sBAAA;AA8OF;AA/PE;EACE,YAAA;AAiQJ;AA/OE;EACE,eAAA;EACA,gBAAA;AAiPJ;;AA7OA;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAgPF;AA9OE;EACE,eAAA;EACA,kBAAA;AAgPJ;AAzOE;EACE,yBAAA;AA2OJ;AAxOE;EACE,oBAAA;AA0OJ;AAvOE;EACE,iBAAA;AAyOJ;AAtOE;;EAEE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAwOJ;AArOE;EAIE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,2DAAA;AAoOJ;AAlOI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AAoON;AAhOE;EACE,YAAA;EACA,aAAA;AAkOJ;AA/NE;EAGE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA+NJ;AA5NE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AA8NJ;AA3NE;EACE,cD3OM;ACwcV;AA1NE;EACE,UAAA;EACA,eAAA;EACA,mBAAA;EACA,2CAAA;EACA,yBAAA;EACA,0DAAA;AA4NJ;AA1NI;;EAEE,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,YAAA;AA4NN;AA1NM;;EACE,cDzNA;ACsbR;AA1NM;;EACE,WAAA;AA6NR;AAzNI;;EAEE,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;AA2NN;AAzNM;;EACE,cDzOA;ACqcR;AAzNM;;EACE,WAAA;AA4NR;AAxNI;EACE,0DAAA;AA0NN;AAvNI;EACE,0DAAA;AAyNN;AAtNI;EACE,0DAAA;AAwNN;AArNI;EACE,sBAAA;EACA,+BAAA;EACA,gCAAA;AAuNN;AArNM;EACE,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAuNR;AApNM;EACE,cAAA;EACA,UAAA;AAsNR;AAnNM;EACE,cAAA;EACA,UAAA;AAqNR;AAhNE;EACE,WAAA;EACA,gBAAA;AAkNJ;AA/MI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cDnUI;ECoUJ,kBAAA;EACA,eAAA;EACA,gBAAA;AAiNN;AA9MI;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;AAgNN;AA9MM;EACE,eAAA;EACA,2BAAA;EACA,cAAA;AAgNR;AA7MM;EACE,8CAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,cAAA;AA+MR;AA7MQ;EAEE,wBAAA;EACA,2BAAA;AA8MV;AA1MM;EACE,gBAAA;AA4MR;AA1MQ;EACE,yBAAA;AA4MV;AAtME;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBD5WW;EC6WX,iBAAA;AAwMJ;AAtMI;EACE,eAAA;EACA,cDxWC;ECyWD,iBAAA;AAwMN;AApME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBDlYY;ECmYZ,YAAA;AAsMJ;AApMI;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AAsMN;AAnMI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AAqMN;AAlMI;EACE,yBDpZI;ACwlBV;AAhME;EACE,kBAAA;EACA,yBD1ZM;EC2ZN,cDtXI;ECuXJ,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAkMJ;AAhMI;EACE,cDjYE;ECkYF,kBAAA;EACA,cAAA;EACA,iBAAA;AAkMN;AA9LE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AAgMJ;AA7LE;EACE,OAAA;AA+LJ;AA5LE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBD1bW;EC2bX,YAAA;EACA,iBAAA;AA8LJ;AA3LE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBDrcW;ECscX,YAAA;AA6LJ;AA3LI;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AA6LN;AA1LI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AA4LN;AAzLI;EACE,yBD7dI;ACwpBV;AAvLE;EACE,kBAAA;EACA,yBDneM;ECoeN,cD/bI;ECgcJ,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAyLJ;AAvLI;EACE,cD1cE;EC2cF,kBAAA;EACA,cAAA;EACA,iBAAA;AAyLN;AArLE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AAuLJ;AApLE;EACE,OAAA;AAsLJ;AAnLE;ED7WA,qBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBCidI;EDtWJ,eCoWI;EDnWJ,gBCoWI;EDnWJ,YCiWI;EDhWJ,gBC+VI;ED9VJ,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;ECgWE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EAGA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAmMJ;AD1iBE;EACE,mBAAA;AC4iBJ;ADziBE;EACE,aAAA;AC2iBJ;ADxiBE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACqiBJ;AD/hBE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;AC+hBJ;AAjNI;EACE,cDvfE;ECwfF,kBAAA;EACA,cAAA;EACA,iBAAA;AAmNN;AA/ME;ED3YA,qBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBC+eI;EDpYJ,eCkYI;EDjYJ,gBCkYI;EDjYJ,YC+XI;ED9XJ,gBC6XI;ED5XJ,mBCwX0B;EDvX1B,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EC8XE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EAGA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AA+NJ;ADpmBE;EACE,mBAAA;ACsmBJ;ADnmBE;EACE,aAAA;ACqmBJ;ADlmBE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC+lBJ;ADzlBE;EAGE,mBCwWuB;EDvWvB,cAvKI;EAwKJ,yBAAA;ACylBJ;AA7OI;EACE,cDrhBE;ECshBF,kBAAA;EACA,cAAA;EACA,iBAAA;AA+ON;AAvOE;;ED7aA,qBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBCkhBI;EDvaJ,eCqaI;EDpaJ,gBCqaI;EDpaJ,YCkaI;EDjaJ,gBCgaI;ED/ZJ,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;ECiaE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EAGA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAuPJ;AD/pBE;;EACE,mBAAA;ACkqBJ;AD/pBE;;EACE,aAAA;ACkqBJ;AD/pBE;;;;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC+pBJ;ADzpBE;;;;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;AC4pBJ;AA7QI;;EACE,cDxjBE;ECyjBF,kBAAA;EACA,cAAA;EACA,iBAAA;AAgRN;AAxQE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AA0QJ;AAvQE;EACE,OAAA;AAyQJ;AAtQE;EACE,aAAA;EACA,8BAAA;EACA,0BAAA;EACA,yBDznBY;EC0nBZ,aAAA;EACA,YAAA;EACA,kBAAA;AAwQJ;AAtQI;EACE,iBAAA;EACA,kBAAA;AAwQN;AArQI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAuQN;AAnQE;EACE,aAAA;EACA,8BAAA;EACA,0BAAA;EACA,yBD9oBY;EC+oBZ,aAAA;EACA,YAAA;EACA,kBAAA;AAqQJ;AAnQI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AAqQN;AAlQI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAoQN;AAhQE;EACE,aAAA;AAkQJ;AAhQI;EACE,iBAAA;AAkQN;AA9PE;EACE,wBAAA;AAgQJ;AA7PE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBDjrBY;ACg7BhB;AA7PI;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AA+PN;AA5PI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AA8PN;AA3PI;EACE,yBDrsBI;ACk8BV;AAzPE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBD1sBY;EC2sBZ,YAAA;AA2PJ;AAzPI;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AA2PN;AAxPI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AA0PN;AAvPI;EACE,yBD/tBI;ACw9BV;AArPE;EACE,aAAA;EACA,sBAAA;AAuPJ;AApPE;EACE,yBDjuBW;ECkuBX,uBAAA;AAsPJ;AApPI;EACE,iBAAA;AAsPN;AAlPE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBDlvBY;ECmvBZ,YAAA;AAoPJ;AAlPI;EACE,eAAA;EACA,sBAAA;EACA,YAAA;AAoPN;AAjPI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AAmPN;AAhPI;EACE,yBDvwBI;ACy/BV;AA9OE;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAgPJ;AA7OE;EACE,oCAAA;EACA,cDhvBI;ECivBJ,2CAAA;AA+OJ;AA5OE;EACE,gBAAA;EACA,mBAAA;AA8OJ;AA5OI;EACE,YAAA;EACA,UAAA;AA8ON;AA1OE;;;EAGE,eAAA;EACA,gBAAA;AA4OJ;AAzOE;EACE,cAAA;AA2OJ;AAxOE;EACE,cAAA;AA0OJ;AAvOE;EACE,cAAA;AAyOJ;;AArOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBDxzBc;ECyzBd,iBAAA;EACA,aAAA;AAwOF;AAtOE;EACE,eAAA;EACA,cDh0BM;ECi0BN,iBAAA;EACA,kBAAA;AAwOJ;;AApOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBDv0Ba;ECw0Bb,iBAAA;EACA,aAAA;AAuOF;AArOE;EACE,eAAA;EACA,cDp0BG;ECq0BH,iBAAA;EACA,kBAAA;AAuOJ;;AAnOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBD/1Bc;ECg2Bd,iBAAA;EACA,aAAA;AAsOF;AApOE;EACE,eAAA;EACA,cDp2BM;ECq2BN,iBAAA;EACA,kBAAA;AAsOJ;;AAlOA;EACE,yBAAA;AAqOF;;AAlOA;EACE,yBAAA;AAqOF;;AAlOA;EACE,mBAAA;AAqOF;;AAlOA;EACE,kCAAA;AAqOF;;AAlOA;EACE,sBAAA;AAqOF;;AAlOA;EAEE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AAoOF;AAlOE;EACE,iCAAA;EACA,gBAAA;EACA,YAAA;AAoOJ;AAhOQ;EACE,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAkOV;AA3NQ;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AA6NV;AA3NU;EACE,iBAAA;EACA,gBAAA;AA6NZ;AA1NU;EACE,iBAAA;EACA,gBAAA;AA4NZ;AAxNY;EACE,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBD56BG;EC66BH,cDr5BN;AC+mCR;AArNY;EACE,cD16BH;EC26BG,gBAAA;AAuNd;AAnNU;EACE,cDh7BD;ACqoCX","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"src/assets/styles/global.scss\";\n\n\n.dropdowns {\n  border-radius: 5px;\n  border: 1px solid #e1e3ea;\n  padding: 3px 5px;\n  margin-bottom: 20px;\n\n  ::ng-deep .mat-mdc-select-placeholder {\n    font-size: 12px !important;\n  }\n\n  ::ng-deep .mat-mdc-select-value-text {\n    color: #535353 !important;\n    font-weight: 400 !important;\n    font-size: 12px !important;\n  }\n\n}\n\n::ng-deep .mat-mdc-option {\n  padding: 5px !important;\n}\n\n::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked {\n  font-size: 12px;\n}\n\n::ng-deep .ng-option {\n  font-size: 12px !important;\n\n  &:hover {\n    background-color: $primary-light !important;\n    color: $primary !important;\n  }\n}\n\n::ng-deep .ng-option-label {\n  font-size: 12px;\n}\n\n::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,\n.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label {\n  color: $primary !important;\n}\n\n::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected {\n  background-color: $primary-light;\n  font-size: 12px !important;\n}\n\n// .ng-dropdown-panel .ng-dropdown-panel-items .ng-option\n::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,\n.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label {\n  font-weight: 400 !important;\n\n  &:hover {\n    color: $primary !important;\n  }\n}\n\n::ng-deep .add-associate-drop-down .ng-dropdown-panel .scroll-host {\n  height: auto !important;\n}\n\n.add-associate-drop-down ::ng-deep .ng-placeholder {\n  color: red !important;\n}\n\n.selectClass {\n  font-size: 12px !important;\n  margin: 7px 0px;\n  background-image: url(\"../../../assets/images/dropdown.svg\");\n  background-repeat: no-repeat;\n  background-position-x: 96%;\n  background-position-y: center;\n  background-color: $primary-light;\n  border-radius: 5px;\n  width: 50% !important;\n  padding: 5px !important;\n  text-align: center;\n\n  mat-select {\n    ::ng-deep .mdc-list-item__primary-text {\n      margin: 0px 40px !important;\n    }\n  }\n}\n\n::ng-deep .mdc-list-item__primary-text {\n  font-size: 12px !important;\n\n  &:hover {\n    color: $primary !important;\n  }\n}\n\n.select {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n\n.remarkTxt {\n  margin-bottom: 15px;\n}\n\nng-select {\n  padding-bottom: 15px;\n}\n\n::ng-deep .ng-select.ng-select-single .ng-select-container .ng-clear-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.image {\n  width: 20px;\n  height: 20px;\n}\n\n.block {\n  cursor: no-drop !important;\n}\n\n::ng-deep .add-associate-modal {\n  width: 38vw !important;\n}\n\n::ng-deep .add-associate-dialog {\n  ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n    height: auto !important;\n    max-height: 530px;\n    overflow: hidden;\n  }\n}\n\n.no-gutter {\n  width: 480px;\n  padding: 30px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.fm-title {\n  margin-bottom: 15px !important;\n  font-size: 16px !important;\n}\n\n.btn-continue {\n  margin-bottom: 30px !important;\n}\n\n::ng-deep .ng-arrow-wrapper {\n  margin-bottom: -5px;\n}\n\n::ng-deep .ng-value {\n  margin-top: -10px !important;\n  padding-left: 8px;\n}\n\n::ng-deep .ng-placeholder {\n  display: none !important;\n}\n\n.add-associate-modal {\n  border-radius: 20px;\n  // box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.16);\n  background-color: $white;\n}\n\n.dialog-header {\n  .close {\n    margin: 10px;\n  }\n\n  // width: 380px;\n  min-height: 229px;\n  max-height: 230px;\n  display: block;\n  text-align: right;\n  // margin-top: 10px;\n  // margin-left: 80px;\n  // @mixin  set-background-image($bg-color, $bg-url, $bg-position, $bg-repeat, $bg-size)\n  @include set-background-image($white,\n    url(\"../../assets/images/deleteFingerprint.svg\"),\n    center,\n    no-repeat,\n    100%);\n  background-size: cover;\n\n  img {\n    cursor: pointer;\n    margin-top: -3px;\n  }\n}\n\n.dialog-body {\n  padding-bottom: 20px;\n  position: relative;\n  max-height: 315px;\n  min-height: 230px;\n  overflow: auto;\n\n  .enroll-status {\n    margin-top: 15%;\n    margin-bottom: 15%;\n  }\n\n  // .shift-down .scan-info {\n  //     margin-top: 20% !important;\n  // }\n\n  .shift-up .scan-info {\n    margin-top: 5% !important;\n  }\n\n  .btn-actions {\n    padding-bottom: 20px;\n  }\n\n  .btn-actions button:nth-of-type(even) {\n    margin-left: 10px;\n  }\n\n  .img-wrapper,\n  .scanned-img-wrapper {\n    margin-left: 38%;\n    margin-top: 8%;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .img-wrapper {\n    // @mixin  create-centered-section($width, $border-radius, $padding-tb, $padding-lr, $border,$background, $left)\n    // @include create-centered-section(150px, 10px, 18px, 5px, none, none, 0);\n\n    width: 100px;\n    height: 100px;\n    border-radius: 10px;\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n    background-image: linear-gradient(135deg, #519548, #88c425);\n\n    img {\n      width: 60%;\n      height: 60%;\n      margin-top: 25%;\n    }\n  }\n\n  .scanned-img-wrapper {\n    width: 100px;\n    height: 100px;\n  }\n\n  .add-space {\n    // @mixin  create-centered-section($width, $border-radius, $padding-tb, $padding-lr, $border,$background, $left)\n    // @include create-centered-section(150px, 10px, 18px, 5px, none, none, 0);\n    margin-bottom: 14%;\n    margin-top: 25%;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .add-info {\n    margin-top: 12px;\n    font-size: 20px;\n    color: #707070;\n  }\n\n  .scan-info {\n    color: $primary;\n  }\n\n  .agent-info {\n    width: 86%;\n    margin-left: 7%;\n    border-radius: 10px;\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n    background-color: #ffffff;\n    background-image: linear-gradient(99deg, #f54828, #f7803c);\n\n    .info-header,\n    .info-header- {\n      padding: 9px 12px 10px;\n      border-top-left-radius: 10px;\n      border-top-right-radius: 10px;\n      height: 40px;\n\n      p {\n        color: $white;\n      }\n\n      img {\n        width: 23px;\n      }\n    }\n\n    .info-header-1,\n    .info-header-1- {\n      padding: 9px 12px 10px;\n      border-top-left-radius: 10px;\n      border-top-right-radius: 10px;\n      height: 103px;\n\n      p {\n        color: $white;\n      }\n\n      img {\n        width: 23px;\n      }\n    }\n\n    .info-header-green {\n      background-image: linear-gradient(99deg, #519548, #519548);\n    }\n\n    .info-header-red {\n      background-image: linear-gradient(99deg, #ff0000, #ff0000);\n    }\n\n    .info-header-orange {\n      background-image: linear-gradient(99deg, #fdb71a, #fdb71a);\n    }\n\n    .info-body {\n      padding: 15px 20px 0px;\n      border-bottom-left-radius: 10px;\n      border-bottom-right-radius: 10px;\n\n      table tbody tr td {\n        padding: 0px !important;\n        border: none !important;\n        text-align: left;\n        font-size: 14px;\n      }\n\n      table tbody tr td:first-child {\n        color: #2d2d2d;\n        width: 45%;\n      }\n\n      table tbody tr td:last-child {\n        color: #707070;\n        width: 55%;\n      }\n    }\n  }\n\n  .form-section {\n    width: 100%;\n    max-width: 380px;\n\n    // margin-left: 5%;\n    .fm-title {\n      width: 100%;\n      font-size: 14px;\n      font-weight: 500;\n      color: $primary;\n      margin-bottom: 5px;\n      margin-left: 4%;\n      text-align: left;\n    }\n\n    .form-group {\n      width: 44%;\n      margin-left: 4%;\n      text-align: left;\n      margin-bottom: 0px !important;\n      margin-top: -15px !important;\n\n      label {\n        font-size: 10px;\n        margin-bottom: 0 !important;\n        color: #707070;\n      }\n\n      .form-control {\n        height: calc(2.4em + 0.75rem - 5px) !important;\n        max-width: 380px;\n        padding: 0 5px;\n        font-size: 12px !important;\n        color: #535353;\n\n        &:focus,\n        &:active {\n          outline: none !important;\n          box-shadow: none !important;\n        }\n      }\n\n      .error-section {\n        min-height: 15px;\n\n        .err-msg {\n          font-size: 9px !important;\n        }\n      }\n    }\n  }\n\n  .mismatch {\n    display: grid;\n    justify-content: center;\n    align-items: center;\n    padding: 30px;\n    border: 1px dotted $dark;\n    background-color: $danger-light;\n    margin: 40px 40px;\n\n    p {\n      font-size: 14px;\n      color: $dark;\n      font-weight: bold;\n    }\n  }\n\n  .leftSuccess {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border: 1px dotted $dark;\n    background-color: $primary-light;\n    margin: 20px;\n\n    img {\n      max-width: 100%;\n      width: 30px !important;\n      height: auto;\n    }\n\n    p {\n      font-size: 14px;\n      color: black;\n      font-weight: bold;\n    }\n\n    button:hover {\n      background-color: $primary;\n    }\n  }\n\n  .continue {\n    padding: 10px 10px;\n    background-color: $primary;\n    color: $white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    font-size: 12px;\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n  }\n\n  .continue::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to right, $gray-button, $gray-button);\n    transition: left 0.5s;\n  }\n\n  .continue:hover::before {\n    left: 0;\n  }\n\n  .deviceErr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border: 1px dotted $dark;\n    background-color: $danger-light;\n    margin: 20px;\n    font-weight: bold;\n  }\n\n  .leftFailed {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border: 1px dotted $dark;\n    background-color: $danger-light;\n    margin: 20px;\n\n    img {\n      max-width: 100%;\n      width: 30px !important;\n      height: auto;\n    }\n\n    p {\n      font-size: 14px;\n      color: black;\n      font-weight: bold;\n    }\n\n    button:hover {\n      background-color: $primary;\n    }\n  }\n\n  .tryAgain {\n    padding: 10px 10px;\n    background-color: $primary;\n    color: $white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    font-size: 12px;\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n  }\n\n  .tryAgain::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to right, $gray-button, $gray-button);\n    transition: left 0.5s;\n  }\n\n  .tryAgain:hover::before {\n    left: 0;\n  }\n\n  .btn-contact {\n    // @mixin create-buttons($bgClr,$clr,$ptb,$plr,$width,$height,$ft-size,$ft-weight,$rad)\n    @include create-buttons($primary,\n      $white,\n      0px,\n      0px,\n      210px,\n      38px,\n      15px,\n      300,\n      5px);\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-right: 8px;\n    margin-left: 6px;\n    // @mixin no-transition($bg-color, $color)\n    @include no-transition($primary, $white);\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n  }\n\n  .delete-assc {\n    // @mixin create-buttons($bgClr,$clr,$ptb,$plr,$width,$height,$ft-size,$ft-weight,$rad)\n    @include create-buttons(#FF4F4F,\n      $white,\n      0px,\n      0px,\n      210px,\n      38px,\n      15px,\n      300,\n      5px);\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-right: 8px;\n    margin-left: 6px;\n    // @mixin no-transition($bg-color, $color)\n    @include no-transition(#FF4F4F, $white);\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n\n    // @include create-buttons($white, $primary-clr-alpha, 6px, 12px, 95px, 39x, 15px, 300, 20px);\n    // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n    // font-family: 'Amazon Ember Display Light';\n  }\n\n  .btn-continue,\n  .add-assc {\n    // @mixin create-buttons($bgClr,$clr,$ptb,$plr,$width,$height,$ft-size,$ft-weight,$rad)\n    @include create-buttons($primary,\n      $white,\n      0px,\n      0px,\n      210px,\n      38px,\n      15px,\n      300,\n      5px);\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-right: 8px;\n    margin-left: 6px;\n    // @mixin no-transition($bg-color, $color)\n    @include no-transition($primary, $white);\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n\n    // @include create-buttons($white, $primary-clr-alpha, 6px, 12px, 95px, 39x, 15px, 300, 20px);\n    // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n    // font-family: 'Amazon Ember Display Light';\n  }\n\n  .hoverEffect::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to right, $gray-button, $gray-button);\n    transition: left 0.5s;\n  }\n\n  .hoverEffect:hover::before {\n    left: 0;\n  }\n\n  .scan {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    border: 1px dotted $dark;\n    background-color: $primary-light;\n    padding: 20px;\n    margin: 20px;\n    border-radius: 5px;\n\n    img {\n      justify-self: end;\n      margin-right: 10px;\n    }\n\n    p {\n      text-align: left;\n      font-size: 12px;\n      font-weight: bold;\n    }\n  }\n\n  .match {\n    display: grid;\n    grid-template-columns: 1fr 3fr;\n    border: 1px dotted $dark;\n    background-color: $primary-light;\n    padding: 20px;\n    margin: 20px;\n    border-radius: 5px;\n\n    img {\n      justify-self: end;\n      margin-right: 10px;\n      max-width: 100%;\n      width: 30px !important;\n      height: auto;\n    }\n\n    p {\n      text-align: left;\n      font-size: 12px;\n      font-weight: bold;\n      margin-top: 5px;\n    }\n  }\n\n  .failedSaving {\n    display: grid;\n\n    p {\n      padding: 10px 0px;\n    }\n  }\n\n  .outer {\n    display: grid !important;\n  }\n\n  .redFlagErr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    background-color: $success-light;\n\n    img {\n      max-width: 100%;\n      width: 30px !important;\n      height: auto;\n    }\n\n    p {\n      font-size: 14px;\n      color: black;\n      font-weight: bold;\n    }\n\n    button:hover {\n      background-color: $primary;\n    }\n  }\n\n  .new {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border: 1px dotted $dark;\n    background-color: $success-light;\n    margin: 20px;\n\n    img {\n      max-width: 100%;\n      width: 30px !important;\n      height: auto;\n    }\n\n    p {\n      font-size: 14px;\n      color: black;\n      font-weight: bold;\n    }\n\n    button:hover {\n      background-color: $primary;\n    }\n  }\n\n  .contactCss {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .redFlag {\n    background-color: $danger-light;\n    justify-content: center;\n\n    p {\n      margin-left: 20px;\n    }\n  }\n\n  .exists {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border: 1px dotted $dark;\n    background-color: $success-light;\n    margin: 20px;\n\n    img {\n      max-width: 100%;\n      width: 30px !important;\n      height: auto;\n    }\n\n    p {\n      font-size: 14px;\n      color: black;\n      font-weight: bold;\n    }\n\n    button:hover {\n      background-color: $primary;\n    }\n  }\n\n  .terms {\n    margin: 10px;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .btn-continue {\n    background-color: $primary !important;\n    color: $white;\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  }\n\n  .slider-wrapper {\n    margin-top: 30px;\n    margin-bottom: 20px;\n\n    mat-slider {\n      height: 48px;\n      width: 78%;\n    }\n  }\n\n  .new-assc,\n  .success,\n  .failure {\n    font-size: 18px;\n    font-weight: 500;\n  }\n\n  .success {\n    color: #5a9d42;\n  }\n\n  .failure {\n    color: #f54a28;\n  }\n\n  .new-assc {\n    color: #ff9900;\n  }\n}\n\n.saving {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px dotted $dark;\n  justify-content: center;\n  background-color: $success-light;\n  margin: 40px 40px;\n  padding: 30px;\n\n  p {\n    font-size: 14px;\n    color: $success;\n    font-weight: bold;\n    text-align: center;\n  }\n}\n\n.savingFailed {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px dotted $dark;\n  justify-content: center;\n  background-color: $danger-light;\n  margin: 40px 40px;\n  padding: 30px;\n\n  p {\n    font-size: 14px;\n    color: $dark;\n    font-weight: bold;\n    text-align: center;\n  }\n}\n\n.updateSucess {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px dotted $dark;\n  justify-content: center;\n  background-color: $primary-light;\n  margin: 40px 40px;\n  padding: 30px;\n\n  p {\n    font-size: 14px;\n    color: $success;\n    font-weight: bold;\n    text-align: center;\n  }\n}\n\n::ng-deep .ng-select.ng-select-disabled>.ng-select-container {\n  background-color: #e9ecef;\n}\n\n::ng-deep .ng-select.ng-select-disabled>.ng-select-container>.ng-value-container>.ng-value {\n  color: #535353 !important;\n}\n\n::ng-deep .ng-select .ng-select-container:after {\n  border-bottom: none;\n}\n\n.addColor {\n  background-color: white !important;\n}\n\n.removeColor {\n  background-color: none;\n}\n\n.table-responsive {\n  // overflow: scroll;\n  margin-top: 10px;\n  box-shadow: none;\n  border: 2px dotted $warning-active;\n  margin: 15px;\n  border-radius: 5px;\n\n  table {\n    font-family: \"Poppins\" !important;\n    box-shadow: none;\n    border: none;\n\n    thead {\n      tr {\n        th {\n          font-size: 14px;\n          border-bottom: none;\n          vertical-align: middle;\n          color: black;\n          text-align: left;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-bottom: none;\n          min-width: 100px;\n          vertical-align: middle;\n          font-size: 13px;\n\n          .name {\n            font-weight: bold;\n            text-align: left;\n          }\n\n          .flexId {\n            font-weight: bold;\n            text-align: left;\n          }\n\n          .name-icon {\n            .prof {\n              text-transform: uppercase;\n              cursor: pointer;\n              border-right: 1px solid $bg-clr;\n              border-top: 1px solid $bg-clr;\n              border-bottom: 1px solid $bg-clr;\n              border-left: 1px solid $bg-clr;\n              border-radius: 3px;\n              padding: 6px 12px;\n              font-size: 18px;\n              text-align: center;\n              margin-right: 10px;\n              background: $warning-active;\n              color: $white;\n            }\n          }\n\n          .user-des {\n            .mobile {\n              color: $gray-500;\n              text-align: left;\n            }\n          }\n\n          .site-name {\n            color: $gray-500;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
